"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const validation_1 = require("../../validation");
const RewardDefinition_1 = require("./RewardDefinition");
const zod_1 = require("zod");
const configSchema = zod_1.z.object({
    campaignId: zod_1.z.string((0, validation_1.labelZodErrors)("Campaign")),
    fundingSourceId: zod_1.z.string((0, validation_1.labelZodErrors)("Funding source")),
    currencyCode: zod_1.z.string((0, validation_1.labelZodErrors)("Currency Code")),
    amount: zod_1.z
        .number((0, validation_1.labelZodErrors)("Amount"))
        .gt(0, "Amount must be greater than 0"),
});
const dataSchema = zod_1.z.object({
    amount: zod_1.z.number(),
    currencyCode: zod_1.z.string(),
    link: zod_1.z.string(),
    tremendousRewardId: zod_1.z.string(),
});
exports.default = new RewardDefinition_1.RewardDefinition("TREMENDOUS_REWARD", configSchema, dataSchema, new validation_1.ValidatorPipeline("TremendousReward", [
    (0, validation_1.createAppLinkedValidator)("tremendous"),
    (0, validation_1.createZodSchemaValidator)(["config"], configSchema),
]), validation_1.NO_OP_VALIDATOR);
//# sourceMappingURL=TREMENDOUS_REWARD.js.map